<template>
  <v-data-table
    :headers="headers"
    :items="entries"
    :items-per-page="10"
    density="compact"
    hover
    class="elevation-0"
  >
    <template v-slot:no-data>
      <div class="text-center pa-4 text-medium-emphasis">
        No entries yet
      </div>
    </template>
    <template v-slot:item.rank="{ item }">
      <div class="font-weight-medium">{{ item.rank }}</div>
    </template>
    <template v-slot:item.points="{ item }">
      <v-chip
        color="primary"
        variant="flat"
        size="small"
        class="font-weight-medium"
      >
        <template v-slot:prepend>
          <span class="mr-1">{{ workspaceEmoji.emojiSymbol || '🙏' }}</span>
        </template>
        {{ item.points }}
      </v-chip>
    </template>
  </v-data-table>
</template>

<script setup lang="ts">
import { useWorkspaceStore } from '../stores/workspaceStore'

interface LeaderboardEntry {
  rank: number
  name: string
  points: number
  slackId: string
}

const headers = [
  { title: 'Rank', key: 'rank', align: 'start' as const, sortable: false },
  { title: 'Handle', key: 'name', align: 'start' as const, sortable: false },
  { title: 'Tokens', key: 'points', align: 'start' as const, sortable: false }
] as const

const { getWorkspaceEmoji } = useWorkspaceStore()
const workspaceEmoji = getWorkspaceEmoji()

defineProps<{
  entries: LeaderboardEntry[]
}>()
</script>
